import { SMS_STORE_ORIGIN_KEY } from '../../common/constants'
import store from '../store'
import { isEmpty } from '@/common/utils'

export const DATA_KEY_IS_TELEVENDAS = 'is_televendas'

const storeIsTelevendas = data => {
  store.set(DATA_KEY_IS_TELEVENDAS, data)
  if (data) store.set(SMS_STORE_ORIGIN_KEY, 'TELEVENDAS')
}

const loadIsTelevendas = async () => {
  const isTelevendas = await store.get(DATA_KEY_IS_TELEVENDAS)

  if (isEmpty(isTelevendas)) {
    return Promise.resolve(false)
  }

  return Promise.resolve(isTelevendas)
}

export { storeIsTelevendas, loadIsTelevendas }
